







import { Component, Vue } from 'vue-property-decorator'
import { Action } from 'vuex-class'

// Components
import Box from '@/components/common/Box.vue'

// Views
import ContactUsModal from '@/views/all/modals/ContactUsModal.vue'

@Component({
  components: {
    Box,
    ContactUsModal
  }
})
export default class TrialExpired extends Vue {
  @Action('resetState') resetState

  mounted() {
    this.resetState()
  }

  openContactModal() {
    this.$modal.open({
      parent: this,
      component: ContactUsModal
    })
  }
}
